import { Components, Theme } from '@mui/material';

export const MuiSvgIconTheme = (): Components<Theme>['MuiSvgIcon'] => {
  return {
    defaultProps: {
      // Default props for all SvgIcon instances
      fontSize: 'inherit',
    },
    styleOverrides: {
      root: {
        // Default styles for all icons
        display: 'inline-block',
        verticalAlign: 'sub',
        flexShrink: 0,
      },
      // Size variants (though we handle this in Icon component)
      fontSizeSmall: {
        width: '16px',
        height: '16px',
        fontSize: '16px',
      },
      fontSizeMedium: {
        width: '24px',
        height: '24px',
        fontSize: '24px',
      },
      fontSizeLarge: {
        width: '32px',
        height: '32px',
        fontSize: '32px',
      },
    },
  };
};
